import _ from 'lodash';

export const Roles = {
  Super: 'super',
  Admin: 'admin',
  User: 'user',
};

export const ContainsAnyRole = (requiredRoles, userRoles) => {
  let roleFound = false;
  _.forEach(userRoles, (role) => {
    if (_.includes(requiredRoles, role)) {
      roleFound = true;
    }
  });
  return roleFound;
};
